import './circleIcon.scss';

export const CircleIconComponent = angular
    .module('app.components.circleIcon', [])
    .component('circleIcon', {
        bindings: {
            icon: '@',
            iconColor: '@',
            svgUrl: '@'
        },
        template: `
            <md-icon ng-if="$ctrl.icon" ng-style="{'color': $ctrl.iconColor || '#000'}">{{$ctrl.icon}}</md-icon>
            <md-icon ng-if="$ctrl.svgUrl" md-svg-src="{{$ctrl.svgUrl}}"></md-icon>
        `,
        transclude: true
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/circleIcon/circleIcon.component.js